export default __webpack_public_path__ + "static/media/sep2023-11.e8faa1ce.jpg";